import React, { FunctionComponent } from "react";
import { Button, Stack } from "@mui/material";
import {
  CloudDownload,
  OpenInNew,
  Restore,
  ZoomIn,
  ZoomOut,
} from "@mui/icons-material";

import { downloadUtilityBillPdf } from "api";
import { downloadFile, openPdfInNewTab } from "utils";

import { UploadDeleteSection } from "./components";
import { FileViewerActionsProps } from "./types";
import { iconWrapperStyle } from "./styles";
import { ZOOM } from "./consts";

export const FileViewerActions: FunctionComponent<FileViewerActionsProps> = ({
  actionsDisabled,
  downloadUrl,
  fileName,
  setScale,
  isFileUploaded,
  successMessage = "",
  deleteTarget = "",
  deleteTitle = "",
}) => (
  <Stack direction="row" spacing={4}>
    <Button
      disabled={actionsDisabled}
      onClick={() =>
        downloadFile(() => downloadUtilityBillPdf(downloadUrl), fileName)
      }
      sx={iconWrapperStyle}
      variant="text"
    >
      <CloudDownload />
    </Button>

    <Button
      disabled={actionsDisabled}
      onClick={() => setScale((s) => s + ZOOM)}
      sx={iconWrapperStyle}
      variant="text"
    >
      <ZoomIn />
    </Button>
    <Button
      disabled={actionsDisabled}
      onClick={() => setScale((s) => s - ZOOM)}
      sx={iconWrapperStyle}
      variant="text"
    >
      <ZoomOut />
    </Button>
    <Button
      disabled={actionsDisabled}
      onClick={() => setScale(0.75)}
      sx={iconWrapperStyle}
      variant="text"
    >
      <Restore />
    </Button>

    <Button
      disabled={actionsDisabled}
      onClick={() => openPdfInNewTab(() => downloadUtilityBillPdf(downloadUrl))}
      sx={iconWrapperStyle}
      variant="text"
    >
      <OpenInNew />
    </Button>

    {isFileUploaded && (
      <UploadDeleteSection
        isFileUploaded={isFileUploaded}
        actionsDisabled={actionsDisabled}
        successMessage={successMessage}
        deleteTarget={deleteTarget}
        deleteTitle={deleteTitle}
      />
    )}
  </Stack>
);
